import { PageHeader } from '@flos/react-ui';
import { useHippoText } from '../../hooks/useHippoText';
import { getCVRHeaderConfig } from './receiptHeaderConfiguration';
import { useRecoilValue } from 'recoil';
import { topConfigContextAtom } from '../../recoil/atoms/topConfigContextAtom';
import { fetchedPaymentInformationAtom } from '../../recoil/atoms/fetchedPaymentInformationAtom';
const ReceiptHeaderCVR = ({
    coverableAmount,
    email
}: {
    coverableAmount: number;
    email: string;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const topConfigContext = useRecoilValue(topConfigContextAtom);
    const paymentMethod = useRecoilValue(fetchedPaymentInformationAtom).paymentMethod ?? '';
    const { title, subtitle, bulletPoints } = getCVRHeaderConfig(
        paymentMethod,
        coverableAmount,
        email,
        getHippoText
    );

    return (
        <PageHeader
            title={title}
            imageUrl={`${topConfigContext?.resourceUrl ?? ''}/images/insurance-2.svg`}
            subtitle={subtitle}
        >
            <div>
                <ul className="u-spacing-stack-l">
                    {bulletPoints.map((text, id) => (
                        <li key={id}>{text}</li>
                    ))}
                </ul>
            </div>
        </PageHeader>
    );
};

export default ReceiptHeaderCVR;
